import { BRAND } from '@/constants/brand'
import { cn } from '@/utils'

/** 论文台字标：目录块 mark + 宋体字（markOnly 时不重复出字） */
export default function BrandLogo({
  className,
  onClick,
  markOnly = false,
}: {
  className?: string
  onClick?: () => void
  markOnly?: boolean
}) {
  const inner = (
    <>
      <svg
        width="40"
        height="40"
        viewBox="0 0 44 44"
        aria-hidden
        className="thesis-brand-mark shrink-0"
      >
        <rect width="44" height="44" rx="6" fill="var(--tt-mark-bg, #1a1a1a)" />
        <rect x="10" y="10" width="24" height="3.5" rx="1" fill="var(--tt-mark-line, #f4f2ee)" />
        <rect x="10" y="18" width="18" height="3" rx="1" fill="var(--tt-mark-line, #f4f2ee)" opacity="0.85" />
        <rect x="10" y="25.5" width="20" height="3" rx="1" fill="var(--tt-mark-line, #f4f2ee)" opacity="0.7" />
        <rect x="10" y="33" width="12" height="3" rx="1" fill="var(--tt-mark-accent, #6b8cae)" />
      </svg>
      {!markOnly && (
        <span
          className="thesis-brand-word text-[1.35rem] font-semibold tracking-[0.08em] leading-none"
          style={{ fontFamily: 'var(--tt-serif, Songti SC, STSong, serif)' }}
        >
          {BRAND.name}
        </span>
      )}
    </>
  )

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        aria-label={BRAND.name}
        className={cn('thesis-brand inline-flex items-center gap-3 border-0 bg-transparent p-0 cursor-pointer', className)}
      >
        {inner}
      </button>
    )
  }

  return (
    <div className={cn('thesis-brand inline-flex items-center gap-3', className)} aria-label={BRAND.name}>
      {inner}
    </div>
  )
}
